var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgImgIndicator = function SvgImgIndicator(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-315.000000, -241.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(315.500000, 241.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13333333,0 L13.8666667,0 C15.04,0 16,0.96 16,2.13333333 L16,13.8666667 C16,15.04 15.04,16 13.8666667,16 L2.13333333,16 C0.96,16 0,15.04 0,13.8666667 L0,2.13333333 C0,0.96 0.96,0 2.13333333,0 Z M11.2,6.4 C12.0533333,6.4 12.8,5.65333333 12.8,4.8 C12.8,3.94666667 12.0533333,3.2 11.2,3.2 C10.3466667,3.2 9.6,3.94666667 9.6,4.8 C9.6,5.65333333 10.3466667,6.4 11.2,6.4 Z M6.93333333,10.56 L5.86666667,8.85333333 C5.86666667,8.74666666 5.76,8.74666666 5.65333333,8.64 C5.33333333,8.53333333 5.01333333,8.53333333 4.90666667,8.85333333 L2.13333333,13.12 L2.13333333,13.3333333 C2.13333333,13.6533333 2.34666666,13.8666667 2.66666667,13.8666667 L13.5466667,13.8666667 C13.76,13.8666667 13.9733333,13.6533333 13.9733333,13.44 C13.9733333,13.3333333 13.9733333,13.2266667 13.8666667,13.2266667 L11.52,9.92 C11.4133333,9.70666667 11.0933333,9.70666667 10.88,9.81333333 L10.7733333,9.92 L10.56,10.1333333 L9.06666667,12.48 C8.85333334,12.6933333 8.53333334,12.8 8.32,12.5866667 C8.21333333,12.5866667 8.21333333,12.48 8.21333333,12.3733333 L6.93333333,10.56 Z",
    id: "\\u5F62\\u72B6"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgImgIndicator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "img-indicator.dd956681559079e35b41be111c221a44.svg";